import { deepSignal } from "deepsignal";
import { useEffect } from "preact/hooks";
import { isTestMode } from "@/util/const.js";

export const TiltifyConfig = {
  tiltifyUserID: isTestMode ? "tiltify-test-user" : "",
  tiltifyUsername: isTestMode ? "test-user" : "",
  tiltifyUserSlug: isTestMode ? "test-user" : "",
  tiltifyCampaignSlug: isTestMode ? "test-campaign" : "",
  tiltifyCampaignID: isTestMode ? "test-campaign-id" : "",
  tiltifyPollID: isTestMode ? "test-poll-id" : "",
  tiltifyCampaignGoal: isTestMode ? "1000" : "0",
  tiltifyCampaignName: isTestMode ? "Test Campaign" : "",
  tiltifyTeamSlug: "",
  tiltifyIsTeamCampaign: false,
  tiltifyAllowRetired: false,
  tiltifyAccessToken: "",
  tiltifyRefreshToken: "",
  tiltifyTokenExpiresIn: "",
  tiltifyTokenCreatedAt: "",
};

const tiltifyConfig = deepSignal(TiltifyConfig);

const useTiltifyConfig = () => {
  useEffect(() => {
    Object.keys(tiltifyConfig).forEach((key) => {
      tiltifyConfig[key] = localStorage.getItem(key) ?? tiltifyConfig[key] ?? null;
    });
  });

  return tiltifyConfig;
};

export default useTiltifyConfig;
